import React from 'react';

/** Tailwind spinner — replaces MUI CircularProgress. `size` in px. */
const Spinner = ({ size = 24, className = '' }) => (
  <svg
    className={`animate-spin text-[#1976d2] ${className}`}
    style={{ width: size, height: size }}
    viewBox="0 0 24 24"
    fill="none"
    aria-label="Loading"
    role="status"
  >
    <circle className="opacity-20" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
    <path
      className="opacity-90"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
    />
  </svg>
);

export default Spinner;
